import { AccountLayout } from '../../layouts';
import { BackupCodeVerificationForm } from '../../components/BackupCodeVerificationForm';

export const BackupCodeVerificationPage = () => {
  return (
    <AccountLayout
      contents={<BackupCodeVerificationForm />}
      contentColumns={5}
    />
  );
};
